var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInneSzlakiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720.85 563.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #9d9d9c;\n      }\n\n      .cls-3 {\n        fill: #00000\n      }\n\n      .cls-2 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M596.41,39.63c0,21.89-17.74,39.63-39.63,39.63s-39.63-17.74-39.63-39.63S534.9,0,556.79,0s39.63,17.74,39.63,39.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.84,361.95c0,8.27-6.7,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.71,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,426.23c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.2,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.7,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.7-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.29,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.71,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.42,426.23c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.9,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.71,14.98-14.98,14.98-14.97-6.71-14.97-14.98,6.7-14.98,14.97-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.67,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.7,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.12,426.23c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.61,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.7,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.37,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.71,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.82,426.23c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.74,411.25c8.27,0,14.98,6.71,14.98,14.98s-6.7,14.98-14.98,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.74,518.91c12.41,0,22.47,10.06,22.47,22.47s-10.06,22.47-22.47,22.47-22.47-10.06-22.47-22.47,10.06-22.47,22.47-22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.98,468.28c8.27,0,14.97,6.71,14.97,14.98s-6.7,14.98-14.97,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.98,411.25c8.27,0,14.97,6.71,14.97,14.98s-6.7,14.98-14.97,14.98S0,434.5,0,426.23s6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.98,526.4c8.27,0,14.97,6.71,14.97,14.98s-6.7,14.98-14.97,14.98-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.3,481.71v-147.95h11.2v147.95h-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.15,363.57l21.35,63.41,9.09,30.86-2.33-32.13v-62.14h11.2v118.15h-10.36l-21.56-62.56-8.45-30.01,1.9,30.65v61.93h-11.2v-118.15h10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.89,363.57l21.35,63.41,9.09,30.86-2.33-32.13v-62.14h11.2v118.15h-10.36l-21.56-62.56-8.45-30.01,1.9,30.65v61.93h-11.2v-118.15h10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.27,373.29v67.63h25.15v9.93h-25.15v20.71h31.49v10.15h-42.69v-118.15h42.69v9.72h-31.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.16,452.12v-14.37h10.99v14.37c-.42,10.99,5.71,21.35,18.39,21.35,11.62,0,17.54-9.3,17.54-20.92v-9.93c0-9.72-8.67-13.53-18.81-19.23-12.05-6.76-26.42-13.74-27.69-30.65v-29.59c0-16.91,8.45-30.44,27.05-30.44,16.7,0,26.21,12.89,26.21,30.01v19.23h-10.78v-19.02c0-10.99-4.23-20.08-15.43-20.08-9.51,0-15.85,6.55-15.85,20.29v29.17c.63,9.72,9.3,15.22,17.97,20.08,15.01,8.45,28.11,14.37,28.11,29.38v10.78c0,16.49-9.09,30.86-28.32,30.86-17.33,0-29.59-12.47-29.38-31.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448.77,371.17l-34.45,100.18h33.82v10.36h-45.44v-8.03l34.87-100.18h-31.28v-9.93h42.48v7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.29,471.78v9.93h-36.35v-118.15h10.99v108.21h25.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M542.82,450.65v.21h-17.12l-4.86,30.86h-10.99l18.18-118.15h12.05l18.39,118.15h-10.99l-4.65-31.07Zm-1.48-9.09l-2.54-17.54-4.65-38.04-4.86,38.04-2.75,17.54h14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M593.12,436.27l33.39,45.44h-13.32l-16.91-21.77-9.09-13.32-2.54,4.86v30.22h-11.2v-118.15h11.2v38.04l-1.06,32.76,13.32-32.55c5.28-12.47,11.2-26,16.49-38.26h11.62l-31.92,72.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.66,481.71v-118.15h10.99v118.15h-10.99Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 427.33,
    y: 130.33,
    width: 187.58,
    height: 258.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 295.23,
    y: 77.5,
    width: 187.58,
    height: 311.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 192.2,
    y: 199.03,
    width: 158.52,
    height: 190.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,233.37c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,297.66c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.7,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,104.8c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.71,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,169.08c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.71,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.85,39.63c0,8.27-6.71,14.98-14.98,14.98s-14.98-6.71-14.98-14.98,6.71-14.98,14.98-14.98,14.98,6.71,14.98,14.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 644.29,
    cy: 39.63,
    r: 14.98,
    transform: "translate(-.17 2.88) rotate(-.26)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInneSzlakiLogo);
export default __webpack_public_path__ + "static/media/inneSzlaki-Logo.bce5ee9e908c5f39b28154545ce8cd64.svg";
export { ForwardRef as ReactComponent };